import { render } from "./SharingBox.vue?vue&type=template&id=310d3c31"
import script from "./SharingBox.vue?vue&type=script&lang=js"
export * from "./SharingBox.vue?vue&type=script&lang=js"

import "./SharingBox.vue?vue&type=style&index=0&id=310d3c31&lang=css"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__